export default {
  SET_COURSE_LIST: 'SET_COURSE_LIST',
  SET_PAGENATION: 'SET_PAGENATION',
  ADD_COURSE_LIST: 'ADD_COURSE_LIST',
  SET_DIFFICULT_GUIDE: 'SET_DIFFICULT_GUIDE',
  SET_PURCHASE_COUNT: 'SET_PURCHASE_COUNT',
  SET_COURSE_COUNT: 'SET_COURSE_COUNT',
  SET_DIFFICULT_DEGREE: 'SET_DIFFICULT_DEGREE',
  SET_SHOWDEGREETIP: 'SET_SHOWDEGREETIP',
  SET_SHOWDIFFCULTRECOMMEND: 'SET_SHOWDIFFCULTRECOMMEND',
  SET_SHOWDIFFICULTDEGREE: 'SET_SHOWDIFFICULTDEGREE',
  SET_SHOWDIFFICULTGUIDE: 'SET_SHOWDIFFICULTGUIDE',
  SET_ISALREADYDEGREE: 'SET_ISALREADYDEGREE',
  SET_ROUTERLOCK: 'SET_ROUTERLOCK',
  SET_COURSE_SIFT: 'SET_COURSE_SIFT',
  SET_SIFT_COURSETYPES: 'SET_SIFT_COURSETYPES',
  SET_SIFT_NAMES: 'SET_SIFT_NAMES',
  SET_SIFT_OTHERS: 'SET_SIFT_OTHERS',
  SET_SIFT_BREAD: 'SET_SIFT_BREAD', // 面包屑
  SET_SIFT_SUBJECTS: 'SET_SIFT_SUBJECTS',
  SET_SIFT_SUBJECT: 'SET_SIFT_SUBJECT',
  SET_SIFT_GRADES: 'SET_SIFT_GRADES',
  SET_SIFT_GRADE: 'SET_SIFT_GRADE',
  SET_SIFT_COURSETYPE: 'SET_SIFT_COURSETYPE',
  UPDATA_COURSE_LIST: 'UPDATA_COURSE_LIST',
  // ========actions=====
  GET_COURSE_LIST: 'GET_COURSE_LIST',
  GET_DIFFICULT_GUIDE: 'GET_DIFFICULT_GUIDE',
  GET_DIFFICULT_DEGREE: 'GET_DIFFICULT_DEGREE',
  GET_COURSE_SIFT: 'GET_COURSE_SIFT'
}



// WEBPACK FOOTER //
// ./src/views/CourseCenter/store/types.js